<template>
  <div id="currentSpeaker-dialog" class="custom-modal">
    <div class="modal-body no-footer">
      <transition name="el-fade-in" mode="out-in">
        <el-row>
          <div class="container-inner" v-if="currentSpeaker != null">
            <div class="profile-picture-container">
              <a :href="currentSpeaker.image" :data-lightbox="'speaker-img-' + currentSpeaker.id" class="profile-picture" :data-title="currentSpeaker.fullName" :style="'background-image: url(' + $imageus + currentSpeaker.image + '?width=300&height=300&mode=cover)'"></a>
              <div class="profile-name">
                <h5 v-if="currentSpeaker.fullName != null">{{ currentSpeaker.fullName }}</h5>
                <p v-if="currentSpeaker.title != null || currentSpeaker.title != ''">{{ currentSpeaker.title }}</p>
                <p v-if="currentSpeaker.firmName != null && currentSpeaker.firmName != ''">
                  <b>@{{ currentSpeaker.firmName }}</b>
                </p>
              </div>
            </div>

            <div class="speaker-section" v-if="currentSpeaker.details != null && currentSpeaker.details != ''">
              <div class="speaker-section-header">
                <div class="section-icon-box">
                  <i class="fas fa-info-circle"></i>
                </div>
                <div class="section-header-title">{{ $t("biography") }}</div>
              </div>
              <div class="speaker-section-body">
                <div class="biograph">
                  <div class="about-text ql-editor ql-container ql-snow" v-html="currentSpeaker.details"></div>
                </div>
              </div>
            </div>
            <div class="speaker-section" v-if="currentSpeakerPrograms.length > 0">
              <div class="speaker-section-header">
                <div class="section-icon-box">
                  <i class="fas fa-calendar"></i>
                </div>
                <div class="section-header-title">{{ $t("programs") }}</div>
              </div>
              <div class="speaker-section-body">
                <div class="speaker-program-container">
                  <div class="speaker-program-item" v-for="(item, index) in currentSpeakerPrograms" :key="index">
                    <div class="speaker-program-item-details">
                      <div class="loc">
                        <span style="margin-right: 12px;flex-shrink:0;"><i class="fas fa-clock" :style="'color:' + currentEvent.color + ';'"></i> {{ getTime(item.startTime) }} <small>-</small> {{ getTime(item.endTime) }}</span>
                        <div class="details-text" v-if="getSaloon(item.saloonID).title != null && getSaloon(item.saloonID).title != undefined && getSaloon(item.saloonID).title != ''"><i class="fas fa-map-marker-alt" :style="'color:' + currentEvent.color + ';'"></i> <span>{{ getSaloon(item.saloonID).title }}</span></div>
                      </div>
                      <span style="flex-shrink:0;" v-if="currentProgramDays.some(k => k.id == item.dayID)">{{ getDate(currentProgramDays.find(k => k.id == item.dayID).date) }}</span>
                    </div>
                    <div class="speaker-program-title" @click="$store.dispatch('getProgram', item.id)">
                      <p>{{ item.title }}</p>
                    </div>

                    <div class="speaker-program-speakers" v-if="item.speakers.length > 0">
                      <div v-for="(speaker, index) in item.speakers.filter(x => x.speakerID != null)" :key="speaker.id + speaker.speakerID + index" @click="$store.dispatch('getSpeaker', speaker.speakerID)">
                        <template v-if="getSpeakerById(speaker.speakerID) != null">
                          <el-tooltip effect="dark" placement="top">
                            <div slot="content" style="text-align:center">
                              <span
                                ><b>{{ getSpeakerById(speaker.speakerID).fullName }}</b>
                              </span>
                              <br />
                              <span>
                                <template v-if="getSpeakerById(speaker.speakerID).title">{{ getSpeakerById(speaker.speakerID).title }}</template>
                                <b v-if="getSpeakerById(speaker.speakerID).firmName"> @ {{ getSpeakerById(speaker.speakerID).firmName }}</b>
                              </span>
                            </div>
                            <div class="speaker-program-speakers-item" :style="'background-image: url(' + $imageus + getSpeakerById(speaker.speakerID).image + '?width=200&height=200&mode=cover);'"></div>
                          </el-tooltip>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="social-bar">
              <div class="social-icon website" v-if="currentSpeaker.externalLinks.some(x => x.type == 4) != '' && currentSpeaker.externalLinks.find(x => x.type == 5).url != null && currentSpeaker.externalLinks.find(x => x.type == 5).isActive">
                <a :href="currentSpeaker.externalLinks.find(x => x.type == 5).url" target="_blank">
                  <i class="fas fa-globe"></i>
                </a>
              </div>

              <div class="social-icon facebook" v-if="currentSpeaker.externalLinks.some(x => x.type == 2) != '' && currentSpeaker.externalLinks.find(x => x.type == 2).url != null && currentSpeaker.externalLinks.find(x => x.type == 2).isActive">
                <a :href="currentSpeaker.externalLinks.find(x => x.type == 2).url" target="_blank">
                  <i class="fab fa-facebook-f"></i>
                </a>
              </div>

              <div class="social-icon twitter" v-if="currentSpeaker.externalLinks.some(x => x.type == 0) != '' && currentSpeaker.externalLinks.find(x => x.type == 0).url != null && currentSpeaker.externalLinks.find(x => x.type == 0).isActive">
                <a :href="currentSpeaker.externalLinks.find(x => x.type == 0).url" target="_blank">
                  <i class="fab fa-twitter"></i>
                </a>
              </div>

              <div class="social-icon linkedin" v-if="currentSpeaker.externalLinks.some(x => x.type == 1) != '' && currentSpeaker.externalLinks.find(x => x.type == 1).url != null && currentSpeaker.externalLinks.find(x => x.type == 1).isActive">
                <a :href="currentSpeaker.externalLinks.find(x => x.type == 1).url" target="_blank">
                  <i class="fab fa-linkedin-in"></i>
                </a>
              </div>

              <div class="social-icon instagram" v-if="currentSpeaker.externalLinks.some(x => x.type == 3) != '' && currentSpeaker.externalLinks.find(x => x.type == 3).url != null && currentSpeaker.externalLinks.find(x => x.type == 3 ).isActive">
                <a :href="currentSpeaker.externalLinks.find(x => x.type == 3).url" target="_blank">
                  <i class="fab fa-instagram"></i>
                </a>
              </div>

              <div class="social-icon google" v-if="currentSpeaker.externalLinks.some(x => x.type == 4) != '' && currentSpeaker.externalLinks.find(x => x.type == 4).url != null && currentSpeaker.externalLinks.find(x => x.type == 4).isActive">
                <a :href="currentSpeaker.externalLinks.find(x => x.type == 4).url" target="_blank">
                  <i class="fab fa-youtube"></i>
                </a>
              </div>
            </div>
            <!-- <div class="currentSpeaker-detail-container" v-html="currentSpeaker.details"></div> -->
          </div>
        </el-row>
      </transition>
    </div>
  </div>
</template>

<script>
import moment from "moment/min/moment-with-locales";
import $ from "jquery";

export default {
  name: "currentSpeakerDialog",

  data() {
    return {
      moment,
      loading: null,
      error: {
        message: null,
        hasError: false
      }
    };
  },

  computed: {
    currentEvent() {
      return this.$store.getters.getEvent;
    },
    currentSpeaker() {
      return this.$store.getters.getCurrentSpeaker;
    },
    currentSpeakerPrograms() {
      return this.$store.getters.getCurrentSpeakerPrograms;
    },
    currentProgramDays() {
      return this.$store.getters.getProgramDays;
    },
    currentProgramSaloons() {
      return this.$store.getters.getProgramSaloons;
    },
    currentProgramSpeakers() {
      return this.$store.getters.getProgramSpeakers;
    },
    currentSubEvents() {
      return this.$store.getters.getSubEvents;
    }
  },

  async mounted() {
    this.$nextTick(async () => {
      await this.$store.dispatch("getPrograms", { id: this.currentEvent.id, route: false });
    });
  },

  methods: {
    openImage(url) {
      $.fancybox.open({
        items: [url]
      });
    },
    getDay(dayID) {
      return this.currentProgramDays.find(k => k.id == dayID);
    },

    getSaloon(saloonID) {
      if (!this.currentProgramSaloons.some(k => k.id == saloonID)) {
        return {
          title: ""
        };
      }
      return this.currentProgramSaloons.find(k => k.id == saloonID);
    },

    getTime(time) {
      time = time.split(":");
      return moment()
        .set({ hours: time[0], minutes: time[1] })
        .format("HH:mm");
    },

    getDate(date) {
      return moment(date).format("Do MMMM");
    },

    getSpeakers() {
      return this.speakers;
    },

    getSpeakerById(id) {
      var speaker = this.currentProgramSpeakers.find(x => x.id == id);
      if (speaker == undefined) {
        speaker == null;
      }
      return speaker;
    }
  }
};
</script>

<style lang="less">
#currentSpeaker-dialog {
  font-family: "Roboto", sans-serif;

  .container-inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    text-align: center;
    gap: 1rem;

    .profile-picture-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      width: 100%;
      gap: 1rem;

      .profile-picture {
        width: 184px;
        height: 184px;
        background-size: cover;
        border-radius: 50%;
        background-position: center;
        border: 6px solid #e8ebef;
        cursor: pointer;
      }

      .profile-name {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        text-align: center;
        gap: 4px;

        h5 {
          margin: 0;
          font-weight: 700;
          font-size: 18px;
          line-height: 24px;
          color: #292f3b;
        }

        p {
          font-weight: 400;
          margin: 0;
          font-size: 14px;
          line-height: 20px;
        }
      }
    }
    .speaker-section {
      padding: 10px 10px 16px 10px;
      background: #ffffff;
      box-shadow: 0px 2px 10px rgba(41, 47, 59, 0.1);
      border-radius: 16px;
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: 1rem;
      .speaker-section-header {
        display: flex;
        align-items: center;
        gap: 10px;
        & > .section-icon-box {
          display: flex;
          align-items: center;
          width: 48px;
          height: 48px;
          justify-content: center;
          background: #f1f3f6;
          border-radius: 50%;
          gap: 10px;
          i {
            font-size: 24px;
            color: #268ea6;
          }
        }
        & > .section-header-title {
          font-weight: 700;
          font-size: 18px;
          color: #292f3b;
          line-height: 24px;
        }
      }
      .speaker-section-body {
        .biograph {
          display: flex;
          flex-direction: column;
          gap: 5px;
          text-align: start;
          .about-text {
            p,
            br,
            hr,
            span {
              margin: 0px;
            }

            h1,
            h2,
            h3,
            h4,
            h5,
            h6 {
              margin: 2px 0px;
            }
            &.clamp {
              display: -webkit-box;
              -webkit-line-clamp: 3;
              -webkit-box-orient: vertical;
              overflow: hidden;
              position: relative;
              &::before {
                position: absolute;
                display: block;
                background: linear-gradient(360deg, #ffffff 11.25%, rgba(255, 255, 255, 0) 100%);
                height: 50%;
                content: "";
                width: 100%;
                bottom: 0;
                left: 0;
                z-index: 2;
              }
            }
          }
          .read-mores {
            font-weight: 700;
            font-size: 14px;
            line-height: 20px;
            color: #505763;
            cursor: pointer;
          }
        }
        .speaker-program-container {
          display: flex;
          flex-direction: column;
          gap: 10px;
          .speaker-program-item {
            border-radius: 12px;
            background: #e8ebef;
            padding: 10px;

            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
            gap: 4px;
            .speaker-program-item-details {
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: space-between;
              width: 100%;
              .loc {
                font-weight: 600;
                font-size: 12px;
                line-height: 18px;
                
                color: #505763;
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: center;
                .details-text {
                  & > span {
                    word-break:break-word;
                  }
                }
                & > span,.details-text {
                  display: flex;
                  flex-direction: row;
                  justify-content: flex-start;
                  align-items: center;
                  i {
                    margin-right: 6px;
                  }
                }
              }
            }

            .speaker-program-title {
              p {
                margin: 0;
                color: #292f3b;
                cursor: pointer;
                font-weight: 600;
                word-break: break-word;
                font-size: 16px;
                line-height: 24px;
              }
            }

            .speaker-program-speakers {
              display: flex;
              align-items: center;
              div {
                background-size: cover;
                background-position: center;
                background-repeat: no-repeat;
                border-radius: 50%;
                width: 38px;
                height: 38px;
                display: inline-block;
                cursor: pointer;
                margin-left: -18px;
                &:first-child {
                  margin-left: 0;
                }
                .speaker-program-speakers-item {
                  border: 3px solid white;
                }
              }
            }
          }
        }
      }
    }
    .social-bar {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      width: 100%;
      margin: 12px 0;

      .social-icon {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-right: 4px;

        &:last-child {
          margin-right: 0px;
        }

        &.website {
          background-color: #288da5;
        }

        &.facebook {
          background-color: #4267b2;
        }

        &.twitter {
          background-color: #1da1f2;
        }

        &.instagram {
          background-color: #c13584;
        }

        &.linkedin {
          background-color: #0077b5;
        }

        &.google {
          background-color: #ff0000;
        }

        &.pinterest {
          background-color: #e60023;
        }

        &.dribble {
          background-color: #ea4c89;
        }

        a {
          i {
            font-size: 20px;
            line-height: 1.2;
            color: white;
          }
        }
      }
    }

    .programdetail-speaker-program-container {
      text-align: left;
      width: 100%;

      h5 {
        text-align: center;
        margin: 6px 0;
        font-size: 14px;
        font-weight: 500;
        color: #292f3b;
      }
    }
  }
}

@media (max-width: 768px) {
}
</style>



// WEBPACK FOOTER //
// src/components/SpeakerDetailDialog.vue